<template>
    <div class="w-full">
        <template v-if="view === 'edit'">
            <div class="alert alert-warning mb-6 text-sm">
                <p>&bull; To enter a link for a chart type #.</p>
                <p>&bull; To enter a link to text select the text you want to add the link to.</p>
                <p>&bull; Drag and drop images where you would like them placed.</p>
            </div>

            <div class="flex flex-wrap mb-2">
                <div class="xs:w-full w-1/2 pr-2 xs:pr-0">
                    <label for="From">From</label>
                    <input class="form-input-inline-w-none w-full" type="date" id="From" v-model="form.dates.from">
                </div>

                <div class="xs:w-full w-1/2 pl-2 xs:pl-0">
                    <label for="To">To</label>
                    <input class="form-input-inline-w-none w-full" type="date" id="To" v-model="form.dates.to">
                </div>
            </div>

            <div class="w-full mb-4">
                <div class="subsection"><p class="subsection-title">Intro Content</p></div>
            </div>

            <div class="w-full mb-4">
                <label for="" class="py-1">Summary</label>
                <div class="pt-2 border-t">
                    <w-editor :content="form.intro.content" :symbols="props.symbols" v-model="form.intro.content"></w-editor>
                </div>
            </div>

            <div class="w-full mb-4">
                <label for="" class="py-1">Closing Message</label>
                <div class="pt-2 border-t">
                    <w-editor :content="form.intro.close" :symbols="props.symbols" v-model="form.intro.close"></w-editor>
                </div>
            </div>

            <div class="w-full mb-4">
                <div class="subsection"><p class="subsection-title">Managed 'Markets' sections</p></div>
            </div>

            <div class="w-full mb-4">
                <div v-for="section in form.sections">
                    <fieldset :class="{'mb-4' : section.items.length > 0}">
                        <div class="flex flex-wrap items-center border-b mb-2 bg-gray-super-100">
                            <div class="inline-block px-4 py-2 font-bold text-base"><i class="fas fa-list mr-2"></i>{{ section.name }}</div>
                            <div class="inline-block ml-auto pr-4">
                                <div @click="addItem(section)" class="btn btn-xs btn-shadow-none"><i class="fas fa-plus"></i><b class="ml-1">Add</b></div>
                            </div>
                        </div>

                        <div v-for="(item, index) in section.items" :class="{'border-t-0' : index > 0}" class="border p-2">
                            <w-editor
                                :class="{'p-2' : section.items.length > 0}"
                                :content="item.content"
                                :symbols="filterSymbolsBySection(section)"
                                v-model="item.content"
                            >
                                <template #menu-bar>
                                    <div @click="removeItem(section.items, index)" class="btn btn-red btn-sm mt-3 mr-2 float-right">
                                        <i class="fa fa-times"></i>
                                        Delete
                                    </div>
                                </template>
                            </w-editor>

                            <input type="hidden" name="direction" :value="item.direction" />
                            <!-- <div class="p-2">
                                <label for="direction">Trend Seeker Direction:</label>
                                <select class="form-control form-control-sm form-control-fixed form-input-modal" name="direction" id="direction" v-model="item.direction">
                                    <option value="up">Up</option>
                                    <option value="down">Down</option>
                                    <option value="neutral">Neutral</option>
                                </select>
                            </div> -->
                        </div>
                    </fieldset>
                </div>
            </div>

            <div class="w-full mb-4">
                <div @click="getPreview" class="btn btn-blue">Preview</div>
            </div>
        </template>

        <template v-if="view === 'preview'">
            <spinner v-if="dataLoading"></spinner>
            <div v-else class="text-center">
                <div v-html="preview"></div>
                <div @click="view = 'edit'" class="btn btn-blue inline-block mt-4 mx-6">Edit</div>
                <div @click="handlePublish" class="btn btn-yellow inline-block mt-4 mx-6">Publish</div>
            </div>
        </template>
    </div>
</template>

<script setup>
import { ref } from 'vue';

const props = defineProps({
    sections: {
        type: Array,
        required: true
    },
    symbols: {
        type: Array,
        required: true
    },
});

const view = ref('edit');
const dataLoading = ref(false);
const preview = ref('');
const articleHtml = ref('');

const form = ref({
    dates: {
        from: (new Date()).toISOString().split('T')[0],
        to: (new Date()).toISOString().split('T')[0]
    },
    intro: {
        title: '',
        content: '',
        close: '<p>I urge you to watch this video to learn how to apply this type of analysis to your trading. You can find the video in the <a href="https://www.commoditytrends.com">Training Video section</a> of our web site.</p>'
    },
    sections: props.sections.map(section => ({
        ...section,
        items: []
    }))
});

const removeItem = (items, index) => {
    items.splice(index, 1);
};

const addItem = (section) => {
    section.items.push({
        content: null,
        direction: 'up'
    });
};

const filterSymbolsBySection = (section) => {
    return props.symbols.filter(s => s.category === section.name);
};

const handlePublish = async () => {
    const route = window.route('admin.newsletter.publish');

    try {
        const response = await axios.post(route, {
            ...form.value,
            html: preview.value,
            articleHtml: articleHtml.value
        });

        // Redirect or perform action after successful response
        window.location = window.route('admin.newsletter');
    } catch (error) {
        // Handle error here
        console.error('Publish error:', error);
    }
};

const getPreview = async () => {
    const route = window.route('admin.newsletter.preview');

    view.value = 'preview';
    dataLoading.value = true;

    try {
        const response = await axios.post(route, form.value);

        // Update the preview and any other necessary data
        preview.value = response.data.html;
        articleHtml.value = response.data.articleHtml;
    } catch (error) {
        // Handle error here
        console.error('Preview error:', error);
    } finally {
        dataLoading.value = false;
    }
};
</script>

